import "./App.css";
import "./ImageTransition.css"; // Importa el archivo CSS para la animación
import bgDark from "./images/bg-desktop-dark.jpg"; // Importa la imagen de fondo para el tema oscuro
import bgLight from "./images/bg-desktop-light.jpg"; // Importa la imagen de fondo para el tema claro
import bgDarkMobile from "./images/bg-mobile-dark.jpg"; // Importa la imagen de fondo para el tema oscuro
import bgLightMobile from "./images/bg-mobile-light.jpg"; // Importa la imagen de fondo para el tema claro
import React, { Component, useEffect, useState } from "react";
import sun from "./images/icon-sun.svg";
import moon from "./images/icon-moon.svg";

import {
  DndContext,
  closestCenter,
  MouseSensor,
  useSensor,
  useSensors,
  DragOverlay,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import {
  restrictToFirstScrollableAncestor,
  restrictToVerticalAxis,
} from "@dnd-kit/modifiers";
import TaskItem from "./TaskItem";

const PreloadImage = ({ src }) => {
  useEffect(() => {
    const image = new Image();
    image.src = src;
  }, [src]);

  return null;
};

const List = (props) => {
  /*const [items, setItems] = useState([
    {
      id: "abc123xyz",
      done: false,
      name: "Complete todo app main from frontendmentor",
    },
    {
      id: "def456uvw",
      done: false,
      name: "Learn new JavaScript frameworks",
    },
    { id: "ghi789rst", done: false, name: "Design a portfolio website" },
    { id: "jkl012pqr", done: false, name: "Create a mobile app prototype" },
    { id: "mno345stu", done: false, name: "Write a tech blog post" },
    {
      id: "pqr678vwx",
      done: false,
      name: "Practice advanced CSS techniques",
    },
    {
      id: "stu901yz0",
      done: false,
      name: "Collaborate on an open-source project",
    },
    {
      id: "vwx234z01",
      done: false,
      name: "Explore machine learning concepts",
    },
    {
      id: "yz0123456",
      done: false,
      name: "Build a responsive web application",
    },
  ]);*/
  const { handleOnDragEnd, filterTaskList, toggleDone, deleteTask } = props;

  /* function handleDragEnd(event) {
    const { active, over } = event;

    if (active.id !== over.id) {
      setItems((items) => {
        const oldIndex = items.findIndex((item) => item.id === active.id);
        const newIndex = items.findIndex((item) => item.id === over.id);
        console.log("oldIndex", oldIndex);
        console.log("newIndex", newIndex);

        return arrayMove(items, oldIndex, newIndex);
      });
    }
  }*/
  const [activeId, setActiveId] = useState(null);

  function handleDragStart(event) {
    setActiveId(event.active.id);
  }

  function handleDragEnd(event) {
    handleOnDragEnd(event);
    setActiveId(null);
  }
  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 5 } })
  );
  return (
    <ul className="items-box">
      <DndContext
        onDragStart={handleDragStart}
        sensors={sensors}
        modifiers={[restrictToVerticalAxis, restrictToFirstScrollableAncestor]}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          strategy={verticalListSortingStrategy}
          items={filterTaskList.map((item) => item.id)}
        >
          {filterTaskList.map((e, i) => {
            return (
              <TaskItem
                opacity="1"
                toggleDone={toggleDone}
                deleteTask={deleteTask}
                key={e.id}
                task={e}
              />
            );
          })}
        </SortableContext>
        <DragOverlay>
          {activeId ? (
            <TaskItem
              opacity="0.5"
              toggleDone={toggleDone}
              deleteTask={deleteTask}
              task={
                filterTaskList[
                  filterTaskList.findIndex((objeto) => objeto.id === activeId)
                ]
              }
              key={activeId}
              value={`Item ${activeId}`}
            />
          ) : null}
        </DragOverlay>
      </DndContext>
    </ul>
  );
};
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newTodoText: "",
      darkTheme: localStorage.getItem("myVariabled") === "true" ? true : false,
      filter: 0,
      tasksList: JSON.parse(localStorage.getItem("myObject")) || [
        {
          id: "abc123xyz",
          done: false,
          name: "Complete todo app main from frontendmentor",
        },
        {
          id: "def456uvw",
          done: false,
          name: "Learn new JavaScript frameworks",
        },
        { id: "ghi789rst", done: false, name: "Design a portfolio website" },
        { id: "jkl012pqr", done: false, name: "Create a mobile app prototype" },
        { id: "mno345stu", done: false, name: "Write a tech blog post" },
        {
          id: "pqr678vwx",
          done: false,
          name: "Practice advanced CSS techniques",
        },
        {
          id: "stu901yz0",
          done: false,
          name: "Collaborate on an open-source project",
        },
        {
          id: "vwx234z01",
          done: false,
          name: "Explore machine learning concepts",
        },
        {
          id: "yz0123456",
          done: false,
          name: "Build a responsive web application",
        },
      ],
    };
    this.imageRef = React.createRef();
  }
  generateUniqueId() {
    return Math.random().toString(36).substr(2, 9);
  }

  handleKeyPress = (event) => {
    if (event.keyCode === 13) {
      var activeElement = document.activeElement;
      var myElement = document.getElementById("focus");
      if (activeElement === myElement && this.state.newTodoText !== "") {
        const newTodo = {
          done: false,
          name: this.state.newTodoText,
        };

        // Crear un conjunto con los ids existentes
        const existingIds = new Set(
          this.state.tasksList.map((task) => task.id)
        );

        // Generar un id único
        let newId = this.generateUniqueId();

        // Verificar si el id generado ya está en uso
        while (existingIds.has(newId)) {
          newId = this.generateUniqueId(); // Generar uno nuevo hasta que sea único
        }

        // Asignar el id único al nuevo objeto
        newTodo.id = newId;

        // Agregar el nuevo objeto al array con el id único
        const updatedTasksList = [newTodo, ...this.state.tasksList];
        this.setState({ newTodoText: "", tasksList: updatedTasksList });
      }
    }
  };
  componentDidUpdate() {
    // Guardar el objeto en el caché cuando el componente se actualiza
    this.applyThemeStyles();

    localStorage.setItem("myObject", JSON.stringify(this.state.tasksList));
    localStorage.setItem("myVariabled", this.state.darkTheme.toString()); // Convertir a cadena
  }
  applyThemeStyles() {
    const root = document.documentElement;
    if (this.state.darkTheme) {
      root.style.setProperty("--color1", "hsl(235, 21%, 11%)");
      root.style.setProperty("--color2", "hsl(235, 24%, 19%)");
      root.style.setProperty("--color3", "hsl(234, 39%, 85%)");
      root.style.setProperty("--color4", "hsl(237, 14%, 26%)");
      root.style.setProperty("--color5", "hsl(233, 14%, 35%)");
      root.style.setProperty("--color6", "hsl(236, 33%, 92%)");
    } else {
      root.style.setProperty("--color1", "hsl(236, 33%, 92%)");
      root.style.setProperty("--color2", "hsl(0, 0%, 98%)");
      root.style.setProperty("--color3", "hsl(235, 19%, 35%)");
      root.style.setProperty("--color4", "hsl(233, 11%, 84%)");
      root.style.setProperty("--color5", "hsl(236, 9%, 61%)");
      root.style.setProperty("--color6", "hsl(237, 14%, 26%)");
    }
  }

  componentDidMount() {
    this.applyThemeStyles();

    // Agrega el event listener cuando el componente se monta
    document.addEventListener("keydown", this.handleKeyPress);
  }

  componentWillUnmount() {
    // Elimina el event listener cuando el componente se desmonta para evitar fugas de memoria
    document.removeEventListener("keydown", this.handleKeyPress);
  }
  handleChange = (event) => {
    this.setState({ newTodoText: event.target.value });
  };
  deleteTask = (index) => {
    const tasksList = this.state.tasksList.filter((e, i) => i !== index);
    this.setState({ tasksList });
  };
  setFilter = (filter) => {
    this.setState({ filter });
  };
  handleOnDragEnd = (result) => {
    const { active, over } = result;
    if (
      !(
        over &&
        typeof over === "object" &&
        Object.prototype.hasOwnProperty.call(over, "id") &&
        over.id
      )
    ) {
      return null;
    }

    if (
      active.id !== null &&
      over !== null &&
      over.id !== null &&
      active.id !== over.id
    ) {
      this.setState((prevState) => {
        const tasksList = Array.from(prevState.tasksList);
        const oldIndex = tasksList.findIndex((task) => task.id === active.id);
        const newIndex = tasksList.findIndex((task) => task.id === over.id);
        const updatedTasksList = arrayMove(tasksList, oldIndex, newIndex);
        return { tasksList: updatedTasksList };
      });
    }
  };

  clearCompleted = () => {
    const tasksList = this.state.tasksList.filter((e) => !e.done);
    this.setState({ tasksList });
  };
  toggleTheme = () => {
    this.setState({ darkTheme: !this.state.darkTheme });
  };
  toggleDone = (index) => {
    const tasksList = [...this.state.tasksList];

    tasksList[index].done = !tasksList[index].done;
    this.setState({ tasksList });
  };
  render() {
    const tasksList = this.state.tasksList.map((e, i) => ({ ...e, index: i }));
    const filterTaskList =
      this.state.filter === 2
        ? tasksList.filter((e, i) => e.done)
        : this.state.filter === 1
        ? tasksList.filter((e, i) => !e.done)
        : tasksList;

    return (
      <div className="App">
        <img
          alt="bg"
          className={`bg-desktop ${this.state.darkTheme ? "dark" : null}`}
          src={bgDark}
        />
        <img
          alt="bg"
          className={`bg-desktop ${!this.state.darkTheme ? "light" : null}`}
          src={bgLight}
        />
        <img
          alt="bg"
          className={`bg-mobile ${this.state.darkTheme ? "dark" : null}`}
          src={bgDarkMobile}
        />
        <img
          alt="bg"
          className={`bg-mobile ${!this.state.darkTheme ? "light" : null}`}
          src={bgLightMobile}
        />
        <main>
          <div className="top">
            <h1>TODO</h1>
            <div onClick={this.toggleTheme} className="theme" alt="theme icon">
              <PreloadImage src={this.state.darkTheme ? sun : moon} />
              {this.state.darkTheme ? (
                <img src={sun} alt="sun" />
              ) : (
                <img src={moon} alt="moon" />
              )}
            </div>
          </div>
          <div className="add-todo item-box">
            <div className="check-circle">
              <div className="undone"></div>
            </div>
            <input
              id="focus"
              onChange={this.handleChange}
              value={this.state.newTodoText}
              placeholder="Create a new todo"
              type="text"
            ></input>
          </div>
          {/* const { handleOnDragEnd, filterTaskList, toggleDone, deleteTask } = props;*/}
          <List
            handleOnDragEnd={this.handleOnDragEnd}
            filterTaskList={filterTaskList}
            toggleDone={this.toggleDone}
            deleteTask={this.deleteTask}
          />
          <div className="task-panel">
            <p className="items-left">
              {this.state.tasksList.length} items left
            </p>
            <div className="desktop filter-buttons">
              <p
                onClick={() => this.setFilter(0)}
                style={
                  this.state.filter === 0
                    ? { color: "hsl(220, 98%, 61%)" }
                    : null
                }
                className="btn"
              >
                All
              </p>
              <p
                onClick={() => this.setFilter(1)}
                style={
                  this.state.filter === 1
                    ? { color: "hsl(220, 98%, 61%)" }
                    : null
                }
                className="btn"
              >
                Active
              </p>
              <p
                onClick={() => this.setFilter(2)}
                style={
                  this.state.filter === 2
                    ? { color: "hsl(220, 98%, 61%)  " }
                    : null
                }
                className="btn"
              >
                Completed
              </p>
            </div>
            <p onClick={this.clearCompleted} className="btn">
              Clear Completed
            </p>
          </div>
          <div className="filter-buttons mobile">
            <div>
              <p
                onClick={() => this.setFilter(0)}
                style={
                  this.state.filter === 0
                    ? { color: "hsl(220, 98%, 61%)" }
                    : null
                }
                className="btn"
              >
                All
              </p>
              <p
                onClick={() => this.setFilter(1)}
                style={
                  this.state.filter === 1
                    ? { color: "hsl(220, 98%, 61%)" }
                    : null
                }
                className="btn"
              >
                Active
              </p>
              <p
                onClick={() => this.setFilter(2)}
                style={
                  this.state.filter === 2
                    ? { color: "hsl(220, 98%, 61%)  " }
                    : null
                }
                className="btn"
              >
                Completed
              </p>
            </div>
          </div>

          <p className="dnd-info">Drag and drop to reorder list</p>
        </main>
      </div>
    );
  }
}
export default App;
